export const Checkmark = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <circle cx="9" cy="9" r="9" fill="#0F3B40" />
      <path
        d="M12.5469 6.55472L8.04684 11.6172L5.79694 9.36719"
        stroke="white"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GradientCheckmark = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      className={className}
    >
      <circle
        cx="8.25"
        cy="8.25"
        r="8.25"
        fill="url(#paint0_linear_2426_5188)"
      />
      <path
        d="M11.5 6.00784L7.37497 10.6485L5.31256 8.58594"
        stroke="white"
        strokeWidth="1.54688"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2426_5188"
          x1="-4.58333"
          y1="21.0833"
          x2="19.2729"
          y2="-2.25811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1CCCF" />
          <stop offset="1" stopColor="#609399" />
        </linearGradient>
      </defs>
    </svg>
  );
};
